module.exports = __webpack_public_path__ + "assets/img/29_255_big.45d98d94.jpg";